export default [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/Home/Index'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/invoices',
        name: 'invoice.index',
        component: () => import('@/pages/Invoice/Index'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/invoices/create',
        name: 'invoice.create',
        component: () => import('@/pages/Invoice/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/invoices/:id',
        name: 'invoice.edit',
        component: () => import('@/pages/Invoice/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/products',
        name: 'product.index',
        component: () => import('@/pages/Product/Index'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/products/create',
        name: 'product.create',
        component: () => import('@/pages/Product/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/products/:id',
        name: 'product.edit',
        component: () => import('@/pages/Product/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/customers',
        name: 'customer.index',
        component: () => import('@/pages/Customer/Index'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/customers/create',
        name: 'customer.create',
        component: () => import('@/pages/Customer/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/customers/:id',
        name: 'customer.edit',
        component: () => import('@/pages/Customer/Edit'),
        meta: {
            auth: true,
        },
    },
    {
        path: '/login',
        name: 'login.index',
        component: () => import('@/pages/Login/Index'),
        meta: {
            guest: true,
        },
    },
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/*',
        redirect: '/dashboard',
    },
];



// WEBPACK FOOTER //
// ./src/routes/index.js